import React, {useState} from 'react';
import PropTypes from 'prop-types';
import BodyQualColSelect from "./BodyQualColSelect";
import {isNil, isNull} from "lodash";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import SubGroupQualColSelect from "./SubGroupQualColSelect";
import SubGroupHtml from "./SubGroupHtml";
import MainGroupHtml from "./MainGroupHtml";
import VehicleHtml from "./VehicleHtml";
import {useTecRmi} from "../../../contexts/TecRmiContext";
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";
import apiUser from "../../../apiUser";
import appUserRoutes from "../../../appUserRoutes";
import {getByModuleId, MODULE_BODY_GRAPHICS} from "../Modules";
import {useHistory} from "react-router-dom";
import useDidMountEffect from "../../../utils/useDidMountEffect";
import ItemGroup from "./ItemGroup";

const BodyGraphicsSelect = props => {
  const history = useHistory()
  const { getApiPrimaryParams, ident } = useTecRmi()
  const [genArtManualList, setGenArtManualList] = useState([])
  const [loading, setLoading] = useState(false)
  const [bodyQualColId, setBodyQualColId] = useState(!isNil(props?.params[0]) ? parseInt(props?.params[0]) : null)
  const [vehicleHtml, setVehicleHtml] = useState(null)
  const [mainGroupId, setMainGroupId] = useState(!isNil(props?.params[1]) ? parseInt(props?.params[1]) : null)
  const [mainGroupHtml, setMainGroupHtml] = useState(null)
  const [subGroupQualColId, setSubGroupQualColId] = useState(!isNil(props?.params[2]) ? parseInt(props?.params[2]) : null)
  const [subGroupId, setSubGroupId] = useState(!isNil(props?.params[3]) ? parseInt(props?.params[3]) : null)
  const [subGroupHtml, setSubGroupHtml] = useState(null)
  const [itemGroupId, setItemGroupId] = useState(!isNil(props?.params[4]) ? parseInt(props?.params[4]) : null)

  useDidMountEffect(() => {
    apiUser.tecRmi.graphics.genArtManualList(getApiPrimaryParams())
      .then(res => setGenArtManualList(res.data))

    if(!isNil(subGroupId)){
      fetchSubGroupHtml()
    }else if(!isNil(mainGroupId)){
      fetchMainGroupHtml()
    }

    updateCrumbs()
    fetchVehicleHtml()
  })

  useAfterUpdateEffect(() => {
    if(isNil(props?.params[0])){
      setMainGroupId(null)
      setMainGroupHtml(null)
    }
    if(isNil(props?.params[2])){
      setSubGroupId(null)
      setSubGroupHtml(null)
      if(!isNil(props?.params[1])){
        fetchMainGroupHtml()
      }
    }
    if(isNil(props?.params[4])){
      setItemGroupId(null)
    }
  }, [props?.params])

  useAfterUpdateEffect(() => {
    updateCrumbs()
  }, [mainGroupId, subGroupId, itemGroupId, genArtManualList])

  useAfterUpdateEffect(() => {
    setMainGroupHtml(null)
    fetchVehicleHtml()
  }, [bodyQualColId])

  useAfterUpdateEffect(() => {
    history.push(appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_BODY_GRAPHICS, 'uriName'), [bodyQualColId, mainGroupId, subGroupQualColId, subGroupId, itemGroupId].join('/')))
  }, [itemGroupId])

  useAfterUpdateEffect(() => {
    history.push(appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_BODY_GRAPHICS, 'uriName'), [bodyQualColId, mainGroupId, subGroupQualColId, subGroupId].join('/')))

    setMainGroupHtml(null)
    fetchSubGroupHtml()
  }, [subGroupQualColId, subGroupId])

  useAfterUpdateEffect(() => {
    history.push(appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_BODY_GRAPHICS, 'uriName'), [bodyQualColId, mainGroupId].join('/')))

    fetchMainGroupHtml()
  }, [mainGroupId])

  const updateCrumbs = () => {
    if(props.onCrumbsUpdated){
      if(genArtManualList.length === 0){
        return []
      }

      const crumbs = []
      let mainGroup, subGroup, itemGroup

      if(mainGroupId){
        mainGroup = genArtManualList.find(genArtManual => genArtManual.MainGroupId === parseInt(mainGroupId))

        crumbs.push({
          name: mainGroup?.MainGroupName || mainGroupId,
          path: appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_BODY_GRAPHICS, 'uriName'), [bodyQualColId, mainGroupId].join('/')),
        })
      }
      if(subGroupId){
        subGroup = mainGroup?.SubGroups?.find(subGroup => subGroup.SubGroupId === parseInt(subGroupId))
        crumbs.push({
          name: subGroup?.SubGroupName || subGroupId,
          path: appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_BODY_GRAPHICS, 'uriName'), [bodyQualColId, mainGroupId, subGroupQualColId, subGroupId].join('/')),
        })
      }
      if(itemGroupId){
        itemGroup = subGroup?.ItemMps?.find(itemMp => itemMp.ItemMpId === parseInt(itemGroupId))
        crumbs.push({
          name: itemGroup?.ItemMpText || itemGroupId,
          path: appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_BODY_GRAPHICS, 'uriName'), [bodyQualColId, mainGroupId, subGroupQualColId, subGroupId, itemGroupId].join('/')),
        })
      }

      props.onCrumbsUpdated(crumbs)
    }
  }

  const fetchVehicleHtml = () => {
    if(!loading && !isNil(bodyQualColId)){
      setLoading(true)
      apiUser.tecRmi.graphics.vehicleHtml({
        ...getApiPrimaryParams(),
        bodyQualColId,
      })
        .then(res => setVehicleHtml(res.data[0]))
        .finally(() => setLoading(false))
    }
  }

  const fetchMainGroupHtml = () => {
    if(!loading && !isNil(mainGroupId)){
      setLoading(true)
      apiUser.tecRmi.graphics.maingroupHtml({
        ...getApiPrimaryParams(),
        bodyQualColId,
        linkUrl: '/',
        mainGroupId: mainGroupId
      })
        .then(res => setMainGroupHtml(res.data[0]))
        .finally(() => setLoading(false))
    }
  }

  const fetchSubGroupHtml = () => {
    if(!loading && !isNil(subGroupId) && !isNil(subGroupQualColId)){
      setLoading(true)
      apiUser.tecRmi.graphics.subgroupHtml({
        ...getApiPrimaryParams(),
        linkUrl: '/',
        bodyQualColId,
        subGroupQualCol: subGroupQualColId,
        subGroupId,
      })
        .then(res => setSubGroupHtml(res.data[0]))
        .finally(() => setLoading(false))
    }
  }

  return <React.Fragment>
    <BodyQualColSelect
      onChange={setBodyQualColId}
    />
    {subGroupId && <SubGroupQualColSelect
        bodyQualColId={bodyQualColId}
        subGroupId={subGroupId}
        onChange={setSubGroupQualColId}
      />}

    {
      itemGroupId
        ? <ItemGroup
          itemGroupId={itemGroupId}
          params={props.params.slice(5)}
          bodyQualColId={bodyQualColId}
          pathPrefix={appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_BODY_GRAPHICS, 'uriName'), [bodyQualColId, mainGroupId, subGroupQualColId, subGroupId, itemGroupId].join('/'))}
        />
        : <React.Fragment>
          {!isNull(bodyQualColId) && <div className="h-100" style={{ maxHeight: '80vh' }}>
            {
              loading
                ? <LoadingSpinner />
                : subGroupId
                  ? <React.Fragment>
                    {subGroupHtml && <SubGroupHtml html={subGroupHtml} onItemGroupIdSelect={setItemGroupId} tecRmiClassName={props.svgStyled ? 'svg-styled' : ''} />}
                  </React.Fragment>
                  : mainGroupHtml
                    ? <MainGroupHtml html={mainGroupHtml} onSubGroupIdSelect={setSubGroupId} tecRmiClassName={props.svgStyled ? 'svg-styled' : ''} />
                    : vehicleHtml && <VehicleHtml html={vehicleHtml} onMainGroupIdSelect={setMainGroupId} tecRmiClassName={props.svgStyled ? 'svg-styled' : ''} />
            }
          </div>}
        </React.Fragment>
    }
  </React.Fragment>;
};

BodyGraphicsSelect.defaultProps = {
  params: [],
  svgStyled: true,
};

BodyGraphicsSelect.propTypes = {
  params: PropTypes.array,
  svgStyled: PropTypes.bool,
  onCrumbsUpdated: PropTypes.func,
};

export default BodyGraphicsSelect;